import { getParentCategories } from "@store/Store/Data/Categories/CategoriesSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { useSelector } from "react-redux";

export const useParentCategories = () => {
    return useSelector((state: StoreApplicationState) => {
        return getParentCategories(state);
    });
};

export default useParentCategories;
